(function () {
  // Use the same section for both preview and quick add
  const SECTION_QV = 'quick-add';
  const SECTION_QA = 'quick-add';

  const modal   = document.getElementById('qv-modal');
  const content = document.getElementById('qv-content');

  // ----- Scroll lock helpers -----
  const _scrollLock = { y: 0, bodyPadRight: '' };
  function lockBodyScroll() {
    const body = document.body;
    const docEl = document.documentElement;
    _scrollLock.y = window.scrollY || window.pageYOffset || 0;

    // Compensate for scrollbar to prevent layout shift
    const scrollbarW = window.innerWidth - docEl.clientWidth;
    _scrollLock.bodyPadRight = body.style.paddingRight;
    if (scrollbarW > 0) body.style.paddingRight = `${scrollbarW}px`;

    body.style.position = 'fixed';
    body.style.top = `-${_scrollLock.y}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.style.paddingRight = _scrollLock.bodyPadRight || '';
    window.scrollTo(0, _scrollLock.y || 0);
  }

  function openModal(){
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    lockBodyScroll();               // <— lock page scroll
  }
  function closeModal(){
    if (!modal || !content) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    content.innerHTML='';
    unlockBodyScroll();             // <— restore page scroll
  }

  // ---------- Tiny toast (under button, subtle styling) ----------
  function toastNear(el, text){
    try {
      const t = document.createElement('div');
      t.textContent = text;
      t.style.position = 'fixed';
      t.style.left = '0px';
      t.style.top  = '0px';
      t.style.transform = 'translate(-50%, 6px)';
      t.style.background = 'rgba(20,20,20,.88)';
      t.style.color = '#fff';
      t.style.padding = '6px 10px';
      t.style.borderRadius = '10px';
      t.style.fontSize = '12px';
      t.style.fontWeight = '500';
      t.style.lineHeight = '1';
      t.style.boxShadow = '0 4px 14px rgba(0,0,0,.12)';
      t.style.zIndex = '2147483647';
      t.style.opacity = '0';
      t.style.transition = 'opacity .18s ease, transform .18s ease';
      t.style.pointerEvents = 'none';
      document.body.appendChild(t);

      const r = (el?.getBoundingClientRect && el.getBoundingClientRect()) || {left:window.innerWidth/2, bottom:window.innerHeight/2, width:0};
      const left = Math.round(r.left + r.width / 2);
      const top  = Math.min(window.innerHeight - 12, Math.round(r.bottom) + 10);
      t.style.left = left + 'px';
      t.style.top  = top  + 'px';

      requestAnimationFrame(() => { t.style.opacity = '1'; t.style.transform = 'translate(-50%, 0)'; });
      setTimeout(() => { t.style.opacity = '0'; t.style.transform = 'translate(-50%, 6px)'; setTimeout(() => t.remove(), 200); }, 1100);
    } catch(_) {}
  }

  // ---- Image preloading cache ----
  const preloadCache = new Map(); // url -> HTMLImageElement
  function preload(url){
    if (!url || preloadCache.has(url)) return;
    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';
    img.src = url;
    preloadCache.set(url, img);
  }
  function isLoaded(url){ const i = preloadCache.get(url); return !!(i && i.complete); }

  // Thumbnails -> main image (fast -> full)
  function wireMediaSwap(root){
    const main = root.querySelector('.qv-main-img, .qv__image');
    if (!main) return;

    const thumbs = root.querySelectorAll('.qv-thumb, .qv__thumb');
    thumbs.forEach(a => preload(a.getAttribute('href'))); // warm cache

    thumbs.forEach(a=>{
      a.addEventListener('click', async (e)=>{
        e.preventDefault();
        const full = a.getAttribute('href');
        const fast = a.dataset.fast || full;

        thumbs.forEach(t=>t.classList.remove('is-active'));
        a.classList.add('is-active');

        if (main.tagName === 'IMG') {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = fast;             // instant feedback
        }

        if (!isLoaded(full)) preload(full);
        const hi = preloadCache.get(full);
        try { if (hi && hi.decode) await hi.decode(); } catch(_) {}
        if (a.classList.contains('is-active') && main.tagName === 'IMG') {
          main.src = full;             // swap to full after decode
        }
      });
    });
  }

  function openSection(handle, sectionId){
    if (!modal || !content) { window.location.assign(`/products/${handle}`); return Promise.reject(); }
    return fetch(`/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`, { credentials:'same-origin' })
      .then(r => r.ok ? r.text() : Promise.reject(r))
      .then(html => {
        content.innerHTML = html;
        openModal();
        attachCloseHandlers(content);
        wireQuickAdd(content);
        wireMediaSwap(content);
        return content;
      })
      .catch(() => { window.location.assign(`/products/${handle}`); });
  }

  // ---------- Add to cart (toast shown on click) ----------
  function quickAdd(variantId, el, handleForFallback){
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(async r => {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(() => {
      document.querySelector('cart-drawer')?.open?.();
      document.querySelector('cart-notification')?.renderContents?.();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(() => {
      if (handleForFallback) openSection(handleForFallback, SECTION_QA);
    });
  }

  function attachCloseHandlers(root){
    root.querySelectorAll('.qa__close, .qv-close, .js-qv-close').forEach(btn=>{
      btn.addEventListener('click', (e)=>{ e.preventDefault(); closeModal(); }, { once:true });
    });
    modal?.querySelector('.qv-overlay')?.addEventListener('click', closeModal, { once:true });
    const esc = (e)=>{ if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', esc); } };
    document.addEventListener('keydown', esc);
  }

  // Close on outside click
  document.addEventListener('mousedown', (e) => {
    if (!modal || !modal.classList.contains('is-open')) return;
    const dialog = modal.querySelector('.qv-dialog');
    if (dialog && !dialog.contains(e.target)) closeModal();
  });

  // ---------- Helpers to read ANY option UI ----------
  function getOptionControls(root){
    const selects = Array.from(root.querySelectorAll('.qa-select, select[name^="options["]'));
    const radioGroups = [];
    Array.from(root.querySelectorAll('input[type="radio"][name^="options["]')).forEach(r=>{
      if (!radioGroups.includes(r.name)) radioGroups.push(r.name);
    });
    return { selects, radioGroups };
  }

  function currentVariantFromUi(variants, root){
    const { selects, radioGroups } = getOptionControls(root);
    const values = [];
    selects.forEach(s => values.push(s.value));
    radioGroups.forEach(name => {
      const checked = root.querySelector(`input[type="radio"][name="${name}"]:checked`);
      if (checked) values.push(checked.value);
    });
    return variants.find(v =>
      (!v.option1 || v.option1 === values[0]) &&
      (!v.option2 || v.option2 === values[1]) &&
      (!v.option3 || v.option3 === values[2])
    ) || null;
  }

  // ---------- Quick Add: price + add ----------
  function wireQuickAdd(root){
    const priceEl = root.querySelector('#qa-price');
    const jsonEl  = root.querySelector('#qa-variants-json');
    const addBtn  = root.querySelector('#qa-add');
    if (!jsonEl) return;

    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent || '[]'); } catch { variants = []; }

    const currency = (priceEl?.dataset.currency ||
                      document.documentElement.getAttribute('data-shop-currency') ||
                      '{{ shop.currency }}').trim();

    function formatMoney(cents){
      const amount = (Number(cents) || 0) / 100;
      try { return new Intl.NumberFormat(undefined, { style:'currency', currency }).format(amount); }
      catch { return '$' + amount.toFixed(2); }
    }

    function updateFromUi(){
      const v = currentVariantFromUi(variants, root) || variants[0];
      if (!v) return;

      if (priceEl){
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
          ? `<div class="price"><s class="price__compare">${formatMoney(v.compare_at_price)}</s> <span class="price__current">${formatMoney(v.price)}</span></div>`
          : `<div class="price"><span class="price__current">${formatMoney(v.price)}</span></div>`;
      }
      if (addBtn){
        addBtn.dataset.variantId = v.id;
        addBtn.disabled = !v.available;
      }
    }

    const { selects, radioGroups } = getOptionControls(root);
    selects.forEach(s => s.addEventListener('change', updateFromUi));
    radioGroups.forEach(name => {
      root.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(r=>{
        r.addEventListener('change', updateFromUi);
        r.addEventListener('click', updateFromUi);
      });
    });

    updateFromUi();

    addBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      // Show toast immediately when pressed (below the button)
      toastNear(addBtn, 'Added to cart');

      const v = currentVariantFromUi(variants, root) || variants[0];
      if (!v?.id) return;
      quickAdd(v.id, addBtn);
    });
  }

  // ---------- Buttons on cards ----------
  ['pointerdown','click'].forEach(evt => {
    document.addEventListener(evt, (e) => {
      const qv  = e.target.closest('.js-quick-view');
      const qa  = e.target.closest('.js-quick-add');
      const qao = e.target.closest('.js-quick-add-open');
      if (!qv && !qa && !qao) return;

      e.stopPropagation();
      if (evt !== 'click') return;
      e.preventDefault();

      if (qv)  { openSection(qv.getAttribute('data-handle'), SECTION_QV); return; }
      if (qao) { openSection(qao.getAttribute('data-handle'), SECTION_QA); return; }
      if (qa)  { quickAdd(qa.getAttribute('data-variant-id'), qa, qa.getAttribute('data-handle')); }
    }, true);
  });

  // Close via overlay / explicit close
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-qv-close') || e.target.classList.contains('qv-overlay')) {
      e.preventDefault(); closeModal();
    }
  });

  function attachCloseHandlers(root){
    root.querySelectorAll('.qa__close, .qv-close, .js-qv-close').forEach(btn=>{
      btn.addEventListener('click', (e)=>{ e.preventDefault(); closeModal(); }, { once:true });
    });
    modal?.querySelector('.qv-overlay')?.addEventListener('click', closeModal, { once:true });
    const esc = (e)=>{ if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', esc); } };
    document.addEventListener('keydown', esc);
  }
})();
/* Reveal .card-actions only after the card's image is ready */
(function () {
  function revealForCard(card) {
    const actions = card.querySelector('.card-actions[hidden]');
    if (!actions) return;

    const show = () => {
      actions.hidden = false;
      actions.classList.add('is-ready');
    };

    // first <img> inside the product card
    const img = card.querySelector('img');
    if (img) {
      if (img.complete && img.naturalWidth > 0) {
        show();
      } else {
        img.addEventListener('load', show, { once: true });
        img.addEventListener('error', show, { once: true }); // fail-safe
        setTimeout(show, 2000); // last resort (cached images / stubborn events)
      }
    } else {
      requestAnimationFrame(show);
    }
  }

  function init(root = document) {
    root.querySelectorAll('.card').forEach(revealForCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Handle cards added later (AJAX filters, infinite scroll, etc.)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (!(n instanceof Element)) continue;
        if (n.matches?.('.card')) revealForCard(n);
        n.querySelectorAll?.('.card')?.forEach(revealForCard);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
